import axios from "axios"
import sapSLErrorFactory from "./utils/sapSLErrorFactory"

//====== WR data 15/09/2026
// Motivo da alteração: reportado pelo usuário — a tela travava (inclusive sem deixar fechar o
// modal, porque `saving` só vira true DEPOIS dessa chamada) esperando pra sempre uma requisição à
// Service Layer real do SAP (ex.: /Login antes de salvar o projeto) que nunca respondia nem dava
// erro. Sem timeout, um problema de rede ou o servidor SAP fora do ar trava a UI indefinidamente.
// 30s é folgado (uma chamada normal leva ~1-2s) mas garante que SEMPRE cai no catch — o próprio
// sapSLErrorFactory(undefined) (erro sem response, caso de timeout) já devolve uma mensagem clara
// ("Service Layer parece estar fora do ar...").
// ======
const apiSap = axios.create({
  withCredentials: true,
  "B1S-CaseInsensitive": true,
  timeout: 30000,
})
apiSap.interceptors.request.use(async (config) => {
  config.url = urlFormatter(config.url)
  return config
})
apiSap.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error?.response?.data?.error?.code === 301) {
      window.location.reload()
    }
    throw sapSLErrorFactory(error.response?.data?.error)
  }
)

function urlFormatter(url) {
  return url.replace("#", "%23")
}
// const apiSap = {
//   post: () => console.log("post"),
//   get: () => console.log("get"),
//   patch: () => console.log("patch"),
//   put: () => console.log("put"),
//   delete: () => console.log("delete"),
// }

export default apiSap
